import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    HistoryDocumentDetailsColumn,
    HistoryDocumentDetailsView,
} from "./historyDocumentDetailsView";

export const defaultHistoryDocumentDetailsView: HistoryDocumentDetailsView = {
    type: ViewType.HISTORY_UPDATED_TRANSACTION,
    columns: [
        { id: HistoryDocumentDetailsColumn.TIME },
        { id: HistoryDocumentDetailsColumn.DOCUMENT_NAME },
        { id: HistoryDocumentDetailsColumn.ENTITY },
        { id: HistoryDocumentDetailsColumn.ACCOUNT },
    ],
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
};

export const defaultHistoryDocumentDownloadView: HistoryDocumentDetailsView = {
    type: ViewType.HISTORY_UPDATED_TRANSACTION,
    columns: [
        { id: HistoryDocumentDetailsColumn.TIME },
        { id: HistoryDocumentDetailsColumn.DOCUMENT_NAME },
        { id: HistoryDocumentDetailsColumn.ENTITY },
    ],
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
};

export const createDefaultHistoryDocumentUpdateView =
    (): HistoryDocumentDetailsView => ({
        type: ViewType.HISTORY_UPDATED_TRANSACTION,
        columns: [
            { id: HistoryDocumentDetailsColumn.TIME },
            { id: HistoryDocumentDetailsColumn.DOCUMENT_NAME },
            { id: HistoryDocumentDetailsColumn.PREVIOUS },
            { id: HistoryDocumentDetailsColumn.MODIFIED },
        ],
        filters: {},
        options: {
            selection: true,
            density: ViewDensity.MD,
        },
    });
